/* src/app/price-list/partials/price-list-accounts/price-list-accounts.component.scss */
/*# sourceMappingURL=price-list-accounts.component.css.map */
